const amount = 5500 * 100; // In paisa
var options = {
  key: 'rzp_live_ILgsfZCZoFIKMb',
  amount: amount,
  name: 'Merchant Name',
  description: 'Fine tshirt',
  image: 'https://i.imgur.com/n5tjHFD.png',
  handler: demoSuccessHandler,
  modal: {
    handleback: true
  }
};

window.r = new Razorpay(options);
$('#paybtn').click(function() {
  r.open();
  $('#optinchat-container').hide();
});

function padStart(str) {
  return ('0' + str).slice(-2);
}

function demoSuccessHandler(transaction) {
  $('#paymentID').text(transaction.razorpay_payment_id);
  var paymentDate = new Date();
  $('#paymentDate').text(
    padStart(paymentDate.getDate()) +
      '.' +
      padStart(paymentDate.getMonth() + 1) +
      '.' +
      paymentDate.getFullYear() +
      ' ' +
      padStart(paymentDate.getHours()) +
      ':' +
      padStart(paymentDate.getMinutes())
  );
  setTimeout(function() {
    showModal('#demo-receipt-modal');
  }, 150);
}

function showModal(modalContainer) {
  var $modalContainer = $(modalContainer);
  $('body').append('<div class="overlay" id="modal-overlay"></div>');
  var $overlay = $('#modal-overlay');

  $overlay.fadeIn();
  $modalContainer
    .show(300, function() {
      $modalContainer.addClass('show');
    })
    .on('click', function(event) {
      var target = event.target;
      if (
        target === $modalContainer[0] ||
        $(target).closest($(this).find('.close')).length
      ) {
        hideModal($modalContainer, $overlay);
      }
    });
}

function hideModal($modalContainer, $overlay) {
  $overlay.fadeOut('fast', function() {
    $(this).remove();
  });
  $modalContainer
    .off('click')
    .removeClass('show')
    .hide(300);
}

// **** Affordability widget handlers *****

document.addEventListener('DOMContentLoaded', function() {
  const rzp = new RazorpayAffordabilitySuite({
    key: 'rzp_live_ILgsfZCZoFIKMb',
    amount: amount
  });
  rzp.render();
});
